import React from 'react';
import Input from '../../Input';
import { useField } from 'react-final-form';
import { validPostalCode } from '../../../services/validators.service';
import { useTranslation } from 'react-i18next';

export default function PostCode({ group, toggleMapping, ...props }) {
    const { t } = useTranslation();

    const {
        input: { value }
    } = useField(toggleMapping[group]?.fieldName);

    return toggleMapping[group][value] === 'show' ? (
        <Input {...props} validators={[validPostalCode(t('error_postalcode_format'))]}></Input>
    ) : null;
}
